// extracted by mini-css-extract-plugin
export default {"root":"Input_root__O-YU0","label":"Input_label__U9NhE","placeholder":"Input_placeholder__llSCe","isFocused":"Input_isFocused__vHrrq","multiline":"Input_multiline__gdYfL"};